import React from "react";
import { injectIntl } from "react-intl";
import { Row } from "antd";
import moment from "moment";
import { UserOutlined } from "@ant-design/icons";
import { getMessageString } from "../../../tools";
import {
  // ID_PAZIENTE,
  INIZIALI_PAZIENTE,
  DATA_INTERVENTO,
  INGRESSO_BLOCCO_OPERATORIO,
  INGRESSO_SALA_OPERATORIA,
  USCITA_SALA_OPERATORIA,
  USCITA_BLOCCO_OPERATORIO,
} from "../../../modules/surgery";
// import { ID_PAZIENTE_TITLE, DATA_INTERVENTO_TITLE } from "../../../modules/language";
import { DATA_INTERVENTO_TITLE } from "../../../modules/language";

const InfoUtenteBase = ({ info, intl }) => (
  <>
    <Row>
      <UserOutlined />
      <div className="infoUtente">
        <span>{info[INIZIALI_PAZIENTE]}</span>
      </div>
    </Row>
    {/* <Row>
      <span className="corsivo">{getMessageString(intl, ID_PAZIENTE_TITLE)}</span>
      <span>{info[ID_PAZIENTE]}</span>
    </Row> */}
    {((info[INGRESSO_BLOCCO_OPERATORIO] && info[INGRESSO_BLOCCO_OPERATORIO] !== undefined) ||
      (info[INGRESSO_SALA_OPERATORIA] && info[INGRESSO_SALA_OPERATORIA] !== undefined) ||
      (info[USCITA_SALA_OPERATORIA] && info[USCITA_SALA_OPERATORIA] !== undefined) ||
      (info[USCITA_BLOCCO_OPERATORIO] && info[USCITA_BLOCCO_OPERATORIO] !== undefined)) && (
      <Row>
        <span className="corsivo">{getMessageString(intl, DATA_INTERVENTO_TITLE)}</span>
        <span style={{ textTransform: "capitalize" }}>{moment(info[DATA_INTERVENTO]).format("dddd D MMMM YYYY")}</span>
      </Row>
    )}
  </>
);
export const InfoUtente = injectIntl(InfoUtenteBase);
